export function removeNullUndefinedObject(
	obj: Record<string, unknown>
): Record<string, unknown> {
	return Object.entries(obj).reduce(
		(acc: Record<string, unknown>, [key, value]: [string, unknown]) => {
			if (
				value !== null &&
				value !== undefined &&
				value !== '' &&
				value !== 'undefined' &&
				value !== 'null'
			) {
				acc[key] =
					typeof value === 'object'
						? removeNullUndefinedObject(value as Record<string, unknown>)
						: value;
			}
			return acc;
		},
		{}
	);
}

export const bytesToSize = (bytes: number): string => {
	const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
	if (bytes === 0) return 'n/a';
	const i = Math.floor(Math.log(Math.abs(bytes)) / Math.log(1024));
	if (i === 0) return `${bytes} ${sizes[i]}`;
	return `${(bytes / 1024 ** i).toFixed(1)} ${sizes[i]}`;
};

export const getPaginationPage = (count: number = 1, pageSize: number = 10) => {
	const mod = count % pageSize;
	const getNext = mod !== 0 ? 1 : 0;
	const totalPage = Math.floor(count / pageSize + getNext);

	return totalPage;
};

export const isNullOrEmpty = (obj: unknown): boolean => {
	if (obj === null || obj === undefined || obj === '') {
		return true;
	}

	if (typeof obj === 'object') {
		return Object.keys(obj).length === 0;
	}

	if (Array.isArray(obj)) {
		return obj.length === 0;
	}

	return false;
};
